import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import { useQuery } from "@tanstack/react-query";
import { getPurchaseFunnelData } from "../../../../api/brandPerformanceApi";
import { RootStateOrAny, useSelector } from "react-redux";

interface Props extends RouteComponentProps {
  diff: number;
  granularity: string;
}

const PurchaseFunnelContent = withRouter((props: Props) => {
  const { diff, history, granularity } = props;

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  const {
    data: purchaseFunnelTrendData,
    isFetching: loadingPurchaseFunnelTrendData,
    refetch: refetchPurchaseFunnelTrendData,
  } = useQuery(["purchaseFunnelTrendData", granularity, history.location.search], () => getPurchaseFunnelData(params), { enabled: false });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchPurchaseFunnelTrendData();
  }, [history.location.search]);

  return (
    <div className="purchase-funnel-main-content">
      <BrandPerformanceTrendTile
        title={`${params.competitor} Purchase Funnel`}
        chartId="purchaseFunnelChart"
        chartData={purchaseFunnelTrendData}
        loadingTrend={loadingPurchaseFunnelTrendData}
        diff={diff}
        isPercentage={true}
        numberFormat="#.0"
        chartGranularity={granularity}
        // chartLegendPosition="right"
      />
    </div>
  );
});

export default PurchaseFunnelContent;
